import { useState, useEffect, useContext } from 'react';
import { IOptionType } from 'components/atoms/SelectBox';
import { apiGetAddress } from 'api/ZimssaAPI';
import useApiRequest, { SUCCESS } from 'hooks/useApiRequest';
import {
  SELECT_DEFAULT_LOCATION_1,
  SELECT_DEFAULT_LOCATION_2,
} from 'commons/ZimssaString';
import { ServiceAction } from 'stores/ServiceStore';

export const drovinceDefault = [{ name: SELECT_DEFAULT_LOCATION_1, value: '' }];
export const cityDefault = [{ name: SELECT_DEFAULT_LOCATION_2, value: '' }];

const useAddress = (initialLocation1 = '') => {
  const [fetchGetProvinceSetResult, fetchGetProvinceSet] =
    useApiRequest<any>(apiGetAddress);
  const [province, setProvince] = useState<string>(initialLocation1);
  const serviceDispatcher = useContext(ServiceAction);
  const [city, setCity] = useState<Array<IOptionType>>(cityDefault);
  const [address, setAddress] = useState<{
    province: Array<string>;
    city: any;
  }>({
    province: [],
    city: {},
  });

  // 군/구 조회 API REQUEST
  useEffect(() => {
    fetchGetProvinceSet({ type: 'REQUEST', body: [] });
  }, [fetchGetProvinceSet]);

  // 군/구 조회 API RESPONSE
  useEffect(() => {
    const { type, data, result } = fetchGetProvinceSetResult;
    if (type === SUCCESS) {
      if (result === 'success' && data) {
        setAddress({
          province: data.province,
          city: data.city,
        });
      }
    }
  }, [fetchGetProvinceSetResult]);

  useEffect(() => {
    const tempCtiy: Array<string> = address.city[`${province}`] ?? [];
    setCity([]);
    setCity([
      ...cityDefault,
      ...tempCtiy.map((item) => ({
        name: item,
        value: item,
      })),
    ]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [province]);

  // NOTE: location2(city)의 값은 location1(province)의 값에 의존적이기 때문에 useEffect를 사용하여 관리합니다.
  // initialLocation1 prop이 넘어온다면 province 상태를 업데이트하여 해당 province에 대응하는 city 목록을 갱신합니다. (위 useEffect 참조.)
  useEffect(() => {
    setProvince(initialLocation1);
  }, [initialLocation1]);

  // NOTE: serviceState는 가정이사, 소형이사, 이사청소에서 공통으로 사용되는 상태이기 때문에 컴포넌트 언마운트 시 초기화합니다.
  // 컴포넌트 마운트 시 serviceState 초기화
  useEffect(() => {
    serviceDispatcher({
      type: 'INIT_STATE',
    });
  }, [serviceDispatcher]);

  const getCityCallback = (province: string): void => {
    setProvince(province);
  };

  return {
    province: [
      ...drovinceDefault,
      ...address.province.map((item) => ({
        name: item,
        value: item,
      })),
    ],
    city,
    getCityCallback,
  };
};

export default useAddress;
